import { BodyLargeEmphasized } from '@/design-system';
import { css } from '@emotion/css';
import aidaIcon from '@/assets/aida.svg';

export const AidaHeader = () => {
  return (
    <div className={cn.container}>
      <img src={aidaIcon} alt="" />
      <BodyLargeEmphasized className={cn.text}>AiDA</BodyLargeEmphasized>
    </div>
  );
};

const cn = {
  container: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
  `,
  text: css`
    transform: translateY(2px);
  `,
};
